import { Controller } from "stimulus";
import Swup from "swup";
import SwupHeadPlugin from "@swup/head-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
// import SwupDebugPlugin from "@swup/debug-plugin";

export default class extends Controller {
  connect() {
    this.swup = new Swup({
      containers: ["#main"],
      animationSelector: '[class*="swup-transition-"]',
      animateHistoryBrowsing: true,
      cache: false,
      plugins: [
        // new SwupDebugPlugin(),
        new SwupHeadPlugin(),
        new SwupScrollPlugin({ animateScroll: false }),
      ],
    });
  }

  disconnect() {
    delete this.swup;
  }
}
